import {useState} from "react";
const CleanInvitationDownload=({url,className=""})=>{
 const [busy,setBusy]=useState(false);
 const save=async event=>{
  event.preventDefault();if(busy)return;setBusy(true);
  try{const response=await fetch(url);if(!response.ok)throw Error("DOWNLOAD_FAILED");const blob=await response.blob(),objectUrl=URL.createObjectURL(blob),link=document.createElement("a");link.href=objectUrl;link.download="invitation.jpg";document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(objectUrl),10000);}
  catch(_error){window.location.assign(url);}
  finally{setBusy(false);}
 };
 return <a href={url} download="invitation.jpg" className={className} onClick={save} aria-busy={busy}>{busy?"מוריד...":"הורדת ההזמנה ללא סימן מים"}</a>;
};
export default CleanInvitationDownload;
